// extracted by mini-css-extract-plugin
module.exports = {"dragAndDrop":"drag_and_drop_dragAndDrop__3bhfM","dragging":"drag_and_drop_dragging__3kZO2"};